// extracted by css-extract-rspack-plugin
export default {"root":"root-QsicF1","headline":"headline-Yn6yGs","video":"video-DFL55b","action":"action-HV9PXM"};